import { render, staticRenderFns } from "./BackofficeOrganizations.vue?vue&type=template&id=8e22474e&scoped=true"
import script from "./BackofficeOrganizations.vue?vue&type=script&lang=js"
export * from "./BackofficeOrganizations.vue?vue&type=script&lang=js"
import style0 from "./BackofficeOrganizations.vue?vue&type=style&index=0&id=8e22474e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e22474e",
  null
  
)

export default component.exports